"use client";

import type { ReactElement } from "react";
import dynamic from "next/dynamic";
import type { CpricingmodalProps } from "@/components/ui/Cpricingmodal";
import type { CnetflixgalleryOverlayProps } from "@/components/ui/Cnetflixgallery";
import type { HomePageControllerLocal } from "./domain/home-page/types";

const Cpricingmodal = dynamic<CpricingmodalProps>(
  () =>
    import("@/components/ui/Cpricingmodal").then(
      (module) => module.Cpricingmodal,
    ),
  { ssr: false },
);
const CnetflixgalleryOverlay = dynamic<CnetflixgalleryOverlayProps>(
  () =>
    import("@/components/ui/Cnetflixgallery").then(
      (module) => module.CnetflixgalleryOverlay,
    ),
  { ssr: false },
);

interface LandingPageModalLayerProps {
  controller: HomePageControllerLocal;
}

export function LandingPageModalLayer({
  controller,
}: LandingPageModalLayerProps): ReactElement {
  return (
    <>
      {controller.hasOpenedPricingModal && (
        <Cpricingmodal
          visible={controller.showPricingModal}
          onClose={controller.handleClosePricingModal}
          onPlanAccess={controller.handlePricingPlanAccess}
          actionLoadingPlanKey={controller.pricingAccessLoadingPlanKey}
        />
      )}
      {/* Browsing (the "All teams" gallery — the Netflix-style rows screen,
          the coverflow deck's successor). Gallery-level close routes through
          the controller so the state never wedges open. Details intents
          (hero inspect / ?viewTeam= restores) render through the app-level
          team-modal host — `showTeamDetailsModal` here is that controller's
          openness, standing the gallery's Escape down while the modal sits
          above it. */}
      {controller.hasOpenedTeamsModal && (
        <CnetflixgalleryOverlay
          visible={controller.showTeamsModal}
          onClose={controller.handleCloseTeamsModal}
          suspended={controller.showTeamDetailsModal}
          onQuickStart={controller.handleGalleryQuickStart}
        />
      )}
    </>
  );
}
